import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Label } from '../components/ui/label';
import { RadioGroup, RadioGroupItem } from '../components/ui/radio-group';
import { Input } from '../components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';
import { toast } from 'sonner';
import { authFetch } from '../lib/authFetch';
import useTheme4A from '../components/useTheme4A';

function OnboardingPage() {
  useTheme4A();
  const { user, checkAuth } = useAuth();
  const navigate = useNavigate();
  const [botName, setBotName] = useState('Tudor');
  const [botGender, setBotGender] = useState('male');
  const [language, setLanguage] = useState('en');

  const handleSubmit = async () => {
    try {
      const response = await authFetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/onboarding`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json'
        },
                body: JSON.stringify({
          bot_name: botName,
          bot_gender: botGender,
          language: language
        })
      });

      if (response.ok) {
        await checkAuth();
        toast.success('Profile updated');
        navigate('/dashboard');
      } else {
        toast.error('Failed to update profile');
      }
    } catch (error) {
      console.error('Onboarding error:', error);
      toast.error('An error occurred');
    }
  };

  return (
    <div className="min-h-screen bg-zinc-100 p-4">
      <div className="max-w-md mx-auto pt-12">
        <h1 className="text-3xl font-bold tracking-tight text-zinc-950 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
          Welcome to ARP
        </h1>
        <p className="text-sm font-medium text-zinc-500 uppercase tracking-wider mb-8">
          PROTOCOL: INITIAL SETUP
        </p>

        <div className="bg-white border border-zinc-200 rounded-md p-6 space-y-6">
          {/* Bot Name */}
          <div>
            <Label className="text-xs font-bold text-zinc-900 uppercase mb-2 block">Sponsor Bot Name</Label>
            <Input
              value={botName}
              onChange={(e) => setBotName(e.target.value)}
              placeholder="Tudor"
              className="bg-white border border-zinc-300 focus:border-zinc-950 focus:ring-1 focus:ring-zinc-950 rounded-md h-12"
              data-testid="bot-name-input"
            />
          </div>

          {/* Bot Gender */}
          <div>
            <Label className="text-xs font-bold text-zinc-900 uppercase mb-2 block">Sponsor Gender Preference</Label>
            <RadioGroup value={botGender} onValueChange={setBotGender} data-testid="bot-gender-radio">
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="male" id="male" />
                <Label htmlFor="male" className="text-base font-normal text-zinc-700">Male</Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="female" id="female" />
                <Label htmlFor="female" className="text-base font-normal text-zinc-700">Female</Label>
              </div>
            </RadioGroup>
          </div>

          {/* Language */}
          <div>
            <Label className="text-xs font-bold text-zinc-900 uppercase mb-2 block">Primary Language</Label>
            <Select value={language} onValueChange={setLanguage}>
              <SelectTrigger className="bg-white border border-zinc-300 rounded-md h-12" data-testid="language-select">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="en">English</SelectItem>
                <SelectItem value="es">Español</SelectItem>
                <SelectItem value="fr">Français</SelectItem>
                <SelectItem value="de">Deutsch</SelectItem>
                <SelectItem value="it">Italiano</SelectItem>
                <SelectItem value="pt">Português</SelectItem>
                <SelectItem value="ru">Русский</SelectItem>
                <SelectItem value="uk">Українська</SelectItem>
                <SelectItem value="ko">한국어</SelectItem>
                <SelectItem value="zh">中文 (简体)</SelectItem>
                <SelectItem value="zh-TW">中文 (繁體)</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <Button
            onClick={handleSubmit}
            className="w-full bg-zinc-950 text-white hover:bg-zinc-800 rounded-md h-12 px-6 font-medium text-sm uppercase tracking-wide"
            data-testid="save-onboarding-btn"
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
}

export default OnboardingPage;